import { useState } from 'react';
import { LOGIN_METHOD_PATH } from '../constants/api';
import { AppConfig } from '../types/app';
import { profileRequest } from '../utils/apiHelper';
import logger from '../utils/logger';
import providersService from '../services/providers';
import { v4 as uuidv4 } from 'uuid';

export interface LoginMethodResponse {
  loginMethods: string[];
}

export async function getLoginMethod(
  config: AppConfig,
  email: string
): Promise<LoginMethodResponse> {
  const clientId = providersService.getClientId();
  const fetchOpts: RequestInit = {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'X-Correlation-ID': uuidv4(),
    },
    body: JSON.stringify({
      emailID: email,
      clientID: clientId,
    }),
  };
  const options = {
    metricNs: 'GetLoginMethod',
    logWithRum: true,
    logWithKatal: true,
  };
  const response = await profileRequest(
    config,
    LOGIN_METHOD_PATH,
    fetchOpts,
    options
  );

  return await response.json();
}

function useLoginMethod(config: AppConfig) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>();
  const [loginMethods, setLoginMethods] = useState<string[] | undefined>();

  function fetchLoginMethod(email: string) {
    setIsLoading(true);
    setError(undefined);
    setLoginMethods(undefined);
    getLoginMethod(config, email)
      .then((result) => {
        if (!result?.loginMethods?.length) {
          throw new Error('No login method found for this email');
        }
        setLoginMethods(result.loginMethods);
      })
      .catch((err) => {
        logger.debug(err);
        setError(err);
      })
      .finally(() => setIsLoading(false));
  }

  function resetLoginMethods() {
    setLoginMethods(undefined);
    setError(undefined);
  }

  return {
    isLoading,
    error,
    loginMethods,
    fetchLoginMethod,
    resetLoginMethods,
  };
}

export default useLoginMethod;
